import {
  Wrapper,
} from './styles'

import ModalContainer from '../../Container'

import { ChatState } from 'components/ChatSystem'
import UserInfoState from 'components/User/UserInfo/UserInfoState'
import Button from 'components/Buttons';

export default function DebugModal() {

  return (
    <ModalContainer size="normal">

      <Wrapper>

        Debug Panel

        <Button onClick={() => ChatState.toggle()} variable="solid" height="big">Toggle chat</Button>
        <Button onClick={() => UserInfoState.toggle()} variable="solid" height="big">Toggle userInfo</Button>

      </Wrapper>


    </ModalContainer>
  );
}